import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'V.T.',
  role: 'Yoga Teacher | New York, USA',
  text: 'The slow flow classes completely changed how my students experience movement. The transitions are already written — I just teach them. My classes feel more professional than ever.'
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Yoga Instructor | Melbourne, Australia',
  text: 'The emergency classes saved me more times than I can count in my first month. I used to panic when my plan fell apart. Now I just open the backup library and teach.'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'Yoga Teacher | Toronto, Canada',
  text: 'I review the key cues before every session and walk in knowing exactly what I am going to say. The cueing library is something I use every single week.'
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'Yoga Instructor | London, United Kingdom',
  text: 'The modification guide gave me back confidence with mixed-ability groups. Before this, I was always nervous when a new student arrived with different mobility needs. Now I have the right option ready before the class even starts.'
}, {
  initials: 'SR',
  name: 'S.R.',
  role: 'Yoga Teacher | Dublin, Ireland',
  text: 'The themed classes were a complete revelation. My students talk about those sessions for weeks. They feel like a real experience, not just a workout.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-66" data-mp="3mpbzaaljda45">
      <div className="max-w-6xl mx-auto" data-id="element-67" data-mp="3mo0tk58j5sae">
        <div className="text-center mb-16" data-id="element-68" data-mp="3mr53zkcl9k9i">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-69" data-mp="3hp63qjc5b3gs">
            What yoga teachers who already have their library are saying:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-70" data-mp="26bc051uilohy">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-71" data-mp="27rprds6wyrkw" data-mpi={i}>
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} data-id="element-72" data-mp="1tu19mt8580k2" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-73" data-mp="1fz8lj6e6tc1v">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-74" data-mp="162vukga11cat" data-mpi={j} />)}
              </div>

              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-75" data-mp="1b1yz7zm3hgi9">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-76" data-mp="rfdopekqabmt">
                <div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-77" data-mp="mh3r6xbj6yy1">
                  {t.initials}
                </div>
                <div data-id="element-78" data-mp="11c06tvlo6ol5">
                  <div className="font-bold text-white" data-id="element-79" data-mp="wfjh4wyto25y">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-80" data-mp="whcnsc9fqmdy">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}